import {
  flow,
  SnapshotIn,
} from 'mobx-state-tree';
import Hades from '@services/Hades';
import { IBenefitTags } from '@stores/ApplicationInterfaces';
import BenefitTag from '@stores/BenefitTag';
import { BenefitTypes, trackBenefitEntityCreated, trackBenefitEntityDeleted, trackBenefitEntityEdited } from '@utils/analytics';

export default {
  actions: (self: { hades: Hades; benefitTags: IBenefitTags }) => ({
    getBenefitTagsList: flow(function* getBenefitTagsList() {
      const result: SnapshotIn<typeof BenefitTag>[] = yield self.hades.request(
        'benefit.tagList',
        {},
      );

      self.benefitTags.clear();

      result.forEach((tag: any) => {
        self.benefitTags.set(tag.id, tag);
      });
    }),

    createBenefitTag: flow(function* createBenefitTag(
      { name }
    ) {
      const tagData = { name };

      const result: SnapshotIn<typeof BenefitTag> = yield self.hades.request(
        'benefit.tagCreate',
        tagData,
      );

      if (result) {
        self.benefitTags.set(`${result.id}`, result);
      }

      trackBenefitEntityCreated(BenefitTypes.Tag, tagData);

      return result;
    }),

    updateBenefitTag: flow(function* updateBenefitTag(
      {
        id: tagId,
        name
      }
    ) {
      const tagData = {
        tagId,
        name,
      };

      const result: SnapshotIn<typeof BenefitTag> = yield self.hades.request(
        'benefit.tagUpdate',
        tagData,
      );

      if (result) {
        self.benefitTags.set(`${result.id}`, result);
      }

      trackBenefitEntityEdited(BenefitTypes.Tag, tagData);

      return result;
    }),

    deleteBenefitTag: flow(function* deleteBenefitTag(
      {
        id: tagId,
      }
    ) {
      const tagData = {
        tagId,
      };

      const result: SnapshotIn<typeof BenefitTag> = yield self.hades.request(
        'benefit.tagDelete',
        tagData,
      );

      if (result) {
        self.benefitTags.delete(`${tagId}`);
      }

      trackBenefitEntityDeleted(BenefitTypes.Tag, tagData);

      return result;
    }),
  }),
};
